import clsx from 'clsx'

type MatterCharacterCounterProps = {
  totalCharCount: number
  softLimit: number
  hardLimit: number
}

export default function MatterCharacterCounter({ totalCharCount, softLimit, hardLimit }: MatterCharacterCounterProps) {
  const isWarning = totalCharCount > softLimit && totalCharCount <= hardLimit
  const isError = totalCharCount > hardLimit

  return (
    <div
      className={clsx('mt-4 px-3 py-2 rounded text-xs text-brand-neutral-800', {
        'bg-brand-neutral-100': !isWarning && !isError,
        'bg-yellow-50': isWarning,
        'bg-red-50': isError,
      })}
    >
      {isWarning || isError ? (
        <div className="flex flex-col gap-0.5">
          <div className="flex items-center justify-between">
            <div className="font-medium">{isError ? 'Character limit exceeded' : 'Character count'}</div>
            <div className={clsx('font-medium', isError ? 'text-red-800' : 'text-yellow-800')}>
              {totalCharCount.toLocaleString()} / {softLimit.toLocaleString()}
            </div>
          </div>
          <div className="font-normal">
            {isError
              ? `Entries more than ${hardLimit.toLocaleString()} characters cannot be saved`
              : `Only the first ${softLimit.toLocaleString()} characters will be included in the matter context.`}
          </div>
        </div>
      ) : (
        <div className="flex items-center justify-between font-medium">
          <div>Character count</div>
          <div>
            {totalCharCount.toLocaleString()} / {softLimit.toLocaleString()}
          </div>
        </div>
      )}
    </div>
  )
}
